import { Dispatch, SetStateAction, useState, useEffect } from "react";
import { UnidadInterface } from "../../../interfaces/UnidadInterface";
import { Button, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faAdd,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { UnidadEditarModal } from "../UnidadEditarModal/UnidadEditarModal";
import { UnidadConfigurarModal } from "../UnidadConfigurarModal/UnidadConfigurarModal";
import { UnidadServiciosModal } from "../UnidadServiciosModal/UnidadServiciosModal";
import { UnidadListSkeleton } from "../../Common/UnidadListSkeleton/UnidadListSkeleton";
import axios from "axios";
import { API } from "../../../global/global";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import {
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";

interface Props {
  unidadesList: UnidadInterface[] | [];
  setValue: UseFormSetValue<FieldValues>;
  getValues: UseFormGetValues<FieldValues>;
  setActividad: Dispatch<SetStateAction<any[]>>;
  actividad: any[];
  isLoading?: boolean;
}

export const UnidadList = ({
  unidadesList,
  setValue,
  getValues,
  setActividad,
  actividad,
  isLoading = false,
}: Props) => {
  const authContext = useContext(AuthContext);
  const [unidadEditar, setUnidadEditar] = useState<UnidadInterface | null>(null);
  const [unidadConf, setUnidadConf] = useState<UnidadInterface | null>(null);
  const [unidadServicios, setUnidadServicios] = useState<UnidadInterface | null>(null);
  const [actividadesUnidad, setActividadesUnidad] = useState<any[]>([]);
  const [contadores, setContadores] = useState<Record<number, number>>({});

  // Cargar contadores optimizados
  useEffect(() => {
    if (unidadesList && unidadesList.length > 0) {
      const unidadIds = unidadesList.map(u => u.id).join(',');
      
      axios.get(`${API}/unidades-contadores?unidad_ids=${unidadIds}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + authContext.token,
        },
      }).then(response => {
        setContadores(response.data.data);
      }).catch(error => {
        console.error('Error cargando contadores:', error);
        setContadores({});
      });
    }
  }, [unidadesList, authContext.token]);

  // Cargar actividades solo para modal de servicios (bajo demanda)
  const handleOpenServiciosModal = (unidad: UnidadInterface) => {
    setUnidadServicios(unidad);
    axios.get(`${API}/actividad?includeAll=true&unidad_id[eq]=${unidad.id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + authContext.token,
      },
    }).then(response => {
      const data = response.data.data || [];
      setActividadesUnidad(data.filter((a: any) => a.tipo_servicio?.revision === true));
    }).catch(error => {
      console.error('Error cargando actividades de unidad:', error);
      setActividadesUnidad([]);
    });
  };

  const handleCloseEditarModal = () => setUnidadEditar(null);
  const handleCloseConfModal = () => setUnidadConf(null);
  const handleCloseServiciosModal = () => setUnidadServicios(null);

  if (isLoading) {
    return <UnidadListSkeleton rows={5} />;
  }

  return (
    <>
      <Row>
        <div
          className="table-responsive"
          style={{
            maxHeight: "300px",
            minHeight: "200px", // Dimensión fija
          }}
        >
          <table className="table table-striped">
            <thead style={{ backgroundColor: "#04144c", color: "white" }}>
              <tr>
                <th scope="col">Revisiones</th>
                <th scope="col">Ticket</th>
                <th scope="col">VIN</th>
                <th scope="col">Placa</th>
                <th scope="col">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {unidadesList && unidadesList.length === 0 && (
                <tr key={"unidad-nada"} className="table-secondary">
                  <td colSpan={5}>
                    No existen unidades asociadas a este cliente.
                  </td>
                </tr>
              )}
              {unidadesList?.map((unidad: any) => (
                <tr key={`unidad-${unidad.id}`}>
                  <td>
                    <Button
                      title="Detalle de revisiones"
                      style={{
                        backgroundColor: "#5DADE2",
                        borderColor: "white",
                      }}
                      onClick={() => handleOpenServiciosModal(unidad)}
                    >
                      {contadores[unidad.id] || 0}
                    </Button>
                  </td>
                  <td>{unidad.ticket}</td>
                  <td>{unidad.vin}</td>
                  <td>{unidad.placa}</td>
                  <td>
                    <Button
                      title="Agregar unidad"
                      style={{
                        backgroundColor: "#5DADE2",
                        borderColor: "white",
                      }}
                      onClick={() => setUnidadConf(unidad)}
                    >
                      <FontAwesomeIcon icon={faAdd as IconProp} />
                    </Button>
                    <Button
                      title="Editar unidad"
                      style={{
                        backgroundColor: "#5DADE2",
                        borderColor: "white",
                      }}
                      onClick={() => setUnidadEditar(unidad)}
                    >
                      <FontAwesomeIcon icon={faEdit as IconProp} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Row>

      {actividad && actividad.length !== 0 && (
        <Row className="mt-3">
          <div
            className="table-responsive"
            style={{
              maxHeight: "300px",
            }}
          >
            <h4>Unidades asignadas a este servicio</h4>
            <table className="table table-striped">
              <thead style={{ backgroundColor: "#04144c", color: "white" }}>
                <tr>
                  <th scope="col">Ticket</th>
                  <th scope="col">VIN</th>
                  <th scope="col">Placa</th>
                  <th scope="col">Tipo de servicio</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {actividad?.map((a) => (
                  <tr
                    key={`unidad-elegida-${a.unidad.id}-${a.tipo_servicio_id}`}
                    className="table-secondary"
                  >
                    <td>{a.unidad.ticket}</td>
                    <td>{a.unidad.vin}</td>
                    <td>{a.unidad.placa}</td>
                    <td>{a.tipoServicio.nombre}</td>
                    <td>
                      <Button
                        title="Quitar unidad"
                        style={{
                          backgroundColor: "#5DADE2",
                          borderColor: "white",
                        }}
                        onClick={() => {
                          setActividad(
                            actividad.filter(
                              (element) =>
                                !(
                                  element.unidad.id === a.unidad.id &&
                                  element.tipo_servicio_id === a.tipo_servicio_id
                                )
                            )
                          );
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash as IconProp} />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Row>
      )}

      {unidadEditar && (
        <UnidadEditarModal
          unidad={unidadEditar}
          handleCloseModal={handleCloseEditarModal}
        />
      )}

      {unidadConf && (
        <UnidadConfigurarModal
          unidad={unidadConf}
          handleCloseModal={handleCloseConfModal}
          setValue={setValue}
          getValues={getValues}
          setActividad={setActividad}
          actividad={actividad}
        />
      )}

      {unidadServicios && (
        <UnidadServiciosModal
          actividades={actividadesUnidad}
          unidad={unidadServicios}
          handleCloseModal={handleCloseServiciosModal}
        />
      )}
    </>
  );
};
